// extracted by mini-css-extract-plugin
export var cardLayout = "_7r-1";
export var paginationContainer = "_7r-0";